// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { chain, SetUserFields } from "@insite/client-framework/Store/Pages/UserSetup/Handlers/SetUserFields";

type HandlerType = Parameters<typeof SetUserFields>[0];

export const SetExtraUserFields = (props: HandlerType) => {
    const { parameter, result } = props;
    if (!result.updatedUser) {
        throw new Error("There was no editingUser set and we are trying to update it.");
    }

    result.updatedUser.properties = {
        ...result.updatedUser.properties,
        financialAccess:
            typeof (parameter as any).financialAccess !== "undefined"
                ? (parameter as any).financialAccess
                : result.updatedUser.properties["financialAccess"],
        acceptConditions:
            typeof (parameter as any).acceptConditions !== "undefined"
                ? (parameter as any).acceptConditions
                : result.updatedUser.properties["acceptConditions"],
    };
};

addToChainAfter(chain, SetUserFields, SetExtraUserFields);
